var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNetworkError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 132,
    viewBox: "0 0 107 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.2609 111.684H5.06604V131.997H101.405V111.684H91.2609ZM96.3331 121.841V126.919H10.1382V116.763H96.3331V121.841Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.411 10.1577V15.2359V20.3141V25.3922V30.4542V35.5323V40.6105V45.6887V50.7669V55.845V60.9232V66.0014V71.0795V76.1577V81.2359V86.3141V91.376V96.4542V101.532V106.611V111.689H106.483V106.611V101.532V96.4542V91.376V86.3141V81.2359V76.1577V71.0795V66.0014V60.9232V55.845V50.7669V45.6887V40.6105V35.5323V30.4542V25.3922V20.3141V15.2359V10.1577H101.411Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.417 5.07886H96.3445V10.157H101.417V5.07886Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2893 5.07817H25.3615H30.4175H35.4897H40.5618H45.634H50.7062H55.7784H60.8506H65.9228H70.995H76.0672H81.1394H86.2116H91.2676H96.3398V0H91.2676H86.2116H81.1394H76.0672H70.995H65.9228H60.8506H55.7784H50.7062H45.634H40.5618H35.4897H30.4175H25.3615H20.2893H15.2171H10.1449V5.07817H15.2171H20.2893Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1382 5.07886H5.06604V10.157H10.1382V5.07886Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07219 101.532V96.4542V91.376V86.3141V81.2359V76.1577V71.0795V66.0014V60.9232V55.845V50.7669V45.6887V40.6105V35.5323V30.4542V25.3922V20.3141V15.2359V10.1577H0V15.2359V20.3141V25.3922V30.4542V35.5323V40.6105V45.6887V50.7669V55.845V60.9232V66.0014V71.0795V76.1577V81.2359V86.3141V91.376V96.4542V101.532V106.611V111.689H5.07219V106.611V101.532Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2109 91.3752V96.4534H20.2831H25.3553V91.3752H20.2831H15.2109Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1392 91.3752H76.0671H70.9949H65.9227V96.4534H70.9949H76.0671H81.1392H86.2114H91.2674V91.3752H86.2114H81.1392Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2125 20.315V25.3932V30.4551V35.5333V40.6114V45.6896V50.7678V55.846V60.9241V66.0023H91.2685V60.9241V55.846V50.7678V45.6896V40.6114V35.5333V30.4551V25.3932V20.315V15.2368H86.2125V20.315Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.418 15.2359H35.4902H40.5624H45.6346H50.7068H55.779H60.8512H65.9234H70.9956H76.0678H81.14H86.2122V10.1577H81.14H76.0678H70.9956H65.9234H60.8512H55.779H50.7068H45.6346H40.5624H35.4902H30.418H25.362H20.2899V15.2359H25.362H30.418Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2831 55.846V50.7678V45.6896V40.6114V35.5333V30.4551V25.3932V20.315V15.2368H15.2109V20.315V25.3932V30.4551V35.5333V40.6114V45.6896V50.7678V55.846V60.9241V66.0023H20.2831V60.9241V55.846Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0678 66H70.9956H65.9234H60.8512H55.779H50.7068H45.6346H40.5624H35.4902H30.418H25.362H20.2899V71.0782H25.362H30.418H35.4902H40.5624H45.6346H50.7068H55.779H60.8512H65.9234H70.9956H76.0678H81.14H86.2122V66H81.14H76.0678Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6394 38.0796H40.5672V43.1578H45.6394V38.0796Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7843 38.0796H50.7121V43.1578H55.7843V38.0796Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9293 38.0796H60.8571V43.1578H65.9293V38.0796Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkError);
export default __webpack_public_path__ + "static/media/network_error.d804b353.svg";
export { ForwardRef as ReactComponent };